export class UploadResponseMessage {
    fileName: string;
    isSuccess: boolean;
    errorMessage: string;
}

export enum FileInputType {
    SIMPLE = 0,
    SELECT = 1
}